import { useMutation } from '@tanstack/react-query'

import { CalculateFormulaResultModel } from '@/domain/model/calculations'

import { addNewCalculateFormulaResult } from './services/addNewCalculateFormulaResult'

export type AddNewCalculateFormulaType = {
  questionId: string
  answers: CalculateFormulaResultModel
  templateId: string | null | undefined
}

export const useAddNewCalculateFormulaResult = () => {
  const mutation = useMutation({
    mutationKey: [''],
    mutationFn: async ({
      questionId,
      answers,
      templateId,
    }: AddNewCalculateFormulaType) =>
      await addNewCalculateFormulaResult(questionId, answers, templateId),
  })

  const addNewCalculateFormulaResultReq = async (
    questionId: string,
    answers: CalculateFormulaResultModel,
    templateId: string | null | undefined
  ) => {
    return mutation.mutateAsync({ questionId, answers, templateId })
  }

  return {
    addNewCalculateFormulaResult: addNewCalculateFormulaResultReq,
    ...mutation,
  }
}
